import script from "./LearningSpaceHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./LearningSpaceHero.vue?vue&type=script&setup=true&lang=ts"

import "./LearningSpaceHero.vue?vue&type=style&index=0&id=abdcf1f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abdcf1f4"]])

export default __exports__